import { globalSettingsBlocFactory } from './chunk-JSTC4PPE.mjs';
import { firestore } from './chunk-CBPAVK33.mjs';

// src/global-settings.ts
var globalSettingsBloc = globalSettingsBlocFactory(firestore);

export { globalSettingsBloc };
//# sourceMappingURL=global-settings.mjs.map
//# sourceMappingURL=global-settings.mjs.map